import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, XCircle } from "lucide-react";

type Props = { ok: boolean };

export default function PayResult({ ok }: Props) {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6">
      <Card className="w-full text-center">
        <CardContent className="space-y-4 py-10">
          {ok ? (
            <CheckCircle2 className="mx-auto h-12 w-12 text-primary" aria-hidden />
          ) : (
            <XCircle className="mx-auto h-12 w-12 text-muted-foreground" aria-hidden />
          )}
          <h1 className="font-display text-2xl font-bold">
            {ok ? "Payment received" : "Payment canceled"}
          </h1>
          <p className="text-sm text-muted-foreground">
            {ok
              ? "Thank you! Your lawn service invoice is now marked paid. A receipt is on its way by email."
              : "No charge was made. You can reopen the payment link any time to finish paying."}
          </p>
          <Button asChild variant="outline">
            <Link to="/">Back to home</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
